export const CURRENT_PAGE = "CURRENT_PAGE";
export const ORDER_TABLE_TAB_STATUS = "ORDER_TABLE_TAB_STATUS";
export const ORDER_TABLE_TAB_SC = "ORDER_TABLE_TAB_SC";
export const USER_STATUS = "USER_STATUS";
export const USER_EMAIL = "USER_EMAIL";
